import { render, staticRenderFns } from "./StartStep.vue?vue&type=template&id=5795ffb3&scoped=true"
import script from "./StartStep.vue?vue&type=script&lang=js"
export * from "./StartStep.vue?vue&type=script&lang=js"
import style0 from "./StartStep.vue?vue&type=style&index=0&id=5795ffb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5795ffb3",
  null
  
)

export default component.exports